import { render, staticRenderFns } from "./VerContratoProveedorModal.vue?vue&type=template&id=8f41fa98&"
import script from "./VerContratoProveedorModal.vue?vue&type=script&lang=ts&"
export * from "./VerContratoProveedorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports